import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/TermsOfService/termsOfService__en-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
  },
  MDXContent: content as DocumentTypes,
};
